// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"628":"1a721c9c","811":"47316ca2"}[chunkId] + ".chunk.css";
};